import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';

const LoadVideoPlayer = Loadable({
    loader: () => import('@ifeng-fe/ui_pc_video/src/myVideo'),
    loading() {
        return <div />;
    },
});

// import { MyVideo } from '@ifeng-fe/ui_pc_video';
// let videoComponent = null;

// import AsyncComponent from './lazyLoad';

class Video extends React.PureComponent {
    static propTypes = {
        guid: PropTypes.string,
    };

    state = {
        // showVideo: typeof window !== 'undefined',
        guid: this.props.guid,
    };

    static getDerivedStateFromProps = (props, state) => {
        let resGuid = {};

        if (props.guid !== state.guid) {
            resGuid = {
                guid: props.guid,
            };
        }

        return {
            ...resGuid,
        };
    };

    render() {
        // console.log('Video=', this.props);
        const { guid } = this.state;

        console.log('guid==', guid);
        const videoConfig = {
            // guid必须，为视频请求id
            guid,
        };

        const playermsg = {
            width: 778, // 播放器的宽度
            height: 450, // 播放器的高度
            isAuth: 'auth', // 是否添加防盗链,建议添加，如果guid请求不到视频地址时会自动转为不添加防盗链
            autoPlay: true, // 是否自动播放 true自动播放/false 不自动播放
        };

        // return showVideo ? <MyVideo videoConfig={videoConfig} playermsg={playermsg} /> : null;
        return (
            <LazyLoad>
                <LoadVideoPlayer videoConfig={videoConfig} playermsg={playermsg} />
            </LazyLoad>
        );
    }
}

export default errorBoundary(Video);
